// extracted by mini-css-extract-plugin
export default {"containerFechas":"FechasEvento_containerFechas__lJkPf","textoPregunta":"FechasEvento_textoPregunta__EajmK","formGroup":"FechasEvento_formGroup__b8vro"};